import { render } from "./StorefrontOrdersList.vue?vue&type=template&id=108e8c6d&scoped=true"
import script from "./StorefrontOrdersList.vue?vue&type=script&lang=js"
export * from "./StorefrontOrdersList.vue?vue&type=script&lang=js"

import "./StorefrontOrdersList.vue?vue&type=style&index=0&id=108e8c6d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-108e8c6d"]])

export default __exports__